/**
 * There will be one reducer file per page / common component
 */
import {
    PUT_FILTEROPTION_SUCCESS,
    PUT_FILTEROPTION_FAILURE,
    PUT_FILTEROPTION,
    RESET_APPLIED_FILTERS_UPDATED,
    RESET_CALENDAR_FILTERS,
    RESET_CALENDAR_FILTERS_SUCCESS,
    RESET_CALENDAR_FILTERS_FAILURE,
} from '../actions';

const initialState = {
    statusCode: 0,
    statusMessage: '',
    filterLoading: false,
    appliedfiltersUpdated: 0,
    resettingFilters: false,
    resettingFiltersSuccess: false,
};

const FilterOptionsUpdated = (state = initialState, action) => {
    switch (action.type) {
        case PUT_FILTEROPTION:
            return {
                ...state,
                filterLoading: true,
            };
        case PUT_FILTEROPTION_SUCCESS: {
            const { statusCode, statusMessage } = action.data;
            return {
                ...state,
                appliedfiltersUpdated: state.appliedfiltersUpdated + 1,
                statusCode: statusCode,
                statusMessage: statusMessage,
                filterLoading: false,
            };
        }
        case PUT_FILTEROPTION_FAILURE:
            return {
                ...state,
                statusCode: 0,
                statusMessage: '',
                filterLoading: false,
            };
        case RESET_APPLIED_FILTERS_UPDATED:
            return {
                ...state,
                appliedfiltersUpdated: 0,
            };
        case RESET_CALENDAR_FILTERS:
            return {
                ...state,
                resettingFilters: true,
                resettingFiltersSuccess: false,
            };
        case RESET_CALENDAR_FILTERS_SUCCESS:
            return {
                ...state,
                resettingFilters: false,
                resettingFiltersSuccess: true,
            };
        case RESET_CALENDAR_FILTERS_FAILURE:
            return {
                ...state,
                resettingFilters: false,
                resettingFiltersSuccess: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default FilterOptionsUpdated;
